export const GA_ORGANIZER_CATEGORY = 'organizer';

// GA tracking dropdown
export const GA_ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const GA_CATEGORY_HEADER = 'header';
export const GA_LABEL_CREATOR_EVENT = 'ViewFromConsumer';

// GA tracking actions
export const GA_PROFILE_CATEGORY = 'organizer';
export const GA_PROFILE_TAB_ACTION = 'OrgProfileNavigationTab';
export const GA_PROFILE_SOCIAL_ACTION = 'ExternalSiteClicked';
export const GA_PROFILE_SHOW_ACTION = 'OrganizerDescription';

export const ORGANIZER_PROFILE_RUM_SAMPLE_RATE = 1;
